import React, { useCallback } from 'react';
import { useForm } from 'react-final-form';

import SumSubProvider from '@swf/verification/SumSubProvider/SumSubProvider';

interface SumSubFieldProps {
  onSuccess: () => void;
  onFailed: () => void;
}
const SumSubField = ({ onSuccess, onFailed }: SumSubFieldProps) => {
  const form = useForm();

  const handleSuccessVerification = useCallback(() => {
    onSuccess();
    form.submit();
  }, [form, onSuccess]);

  const handleFailedVerification = useCallback(() => {
    onFailed();
    form.submit();
  }, [form, onFailed]);

  return (
    <SumSubProvider onSuccess={handleSuccessVerification} onFailed={handleFailedVerification} />
  );
};

export default SumSubField;
